var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-form customer-details-open"},[_c('button',{staticClass:"submit-form-button",attrs:{"type":"submit","autocomplete":"off"},domProps:{"innerHTML":_vm._s(_vm.$store.state.texts.submitBtn)},on:{"click":function($event){$event.preventDefault();return _vm.validateAll()}}}),_vm._v(" "),_c('noscript')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-317468fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/SubmitBtn.vue
// module id = null
// module chunks = 